import React from 'react'
import intl from 'react-intl-universal'
import { Card, Image } from 'antd-mobile'
import { renderImageUrl } from '../../../utils'
import styles from './menu.module.less'
import PriceText from '../../ProductMenu/PriceText'
import ProductOriPrice from '../../ProductOriPrice'
import { isInSellingTime } from '../../../utils/bookRule'

import defImg from '../../../assets/images/def_img_food.png'

export default function RecommendMenu({ list = {}, events = {}, readonly = false, storeInfo = {} }) {

    const { renderProductActions } = events
    const { productImages = '' } = storeInfo || {}

    let defaultImage = productImages || defImg

    //是否可订
    const canOrderItem = (item) => {
        const inSellingTime = isInSellingTime(item.sellingTimeRange, item.sellingTimeRangeJson).state
        const isActive = !(item.stock === 0 || item.status === 2) && inSellingTime

        // console.log(isActive,'////====isActive===',item)
        return isActive
    }


    return (
        <div className={styles.recommendMenu}>
            <Card title={intl.get('you_may_like').d('You may also like')}>
                <ul className={`${styles.menuList} jm-scrollx-box `}>
                    {
                        list.map((item, index) => {
                            if (!canOrderItem(item)) return null

                            const img =  item.images || defaultImage
                            return <li
                                className={styles.menuItem}
                                key={index}
                            >
                                <Image
                                    className={styles.menuImg}
                                    src={renderImageUrl({ size: 's', src: img })}
                                    alt={item.productName}
                                    onError={e => e.target.src = defaultImage}
                                    style={{ borderRadius: 10 }}
                                    lazy
                                />
                                <div className={`${styles.menuName} ellips`}>
                                    {item.productName || item.name}
                                </div>
                                <div className={styles.productPriceWrapper}>
                                    <div className={styles.productPrice}>
                                        <span>
                                            <PriceText product={item} />
                                        </span>
                                        <ProductOriPrice item={item} />
                                    </div>
                                    <div className={styles.productAction}>
                                        {!readonly && renderProductActions(item, styles.productNum)}
                                    </div>
                                </div>
                            </li>
                        })
                    }
                </ul>
            </Card>

        </div>
    )
}
